<template>
  <div>
    <h3 class="title">Campaigns</h3>
    <div v-if="campaigns">
      <CampaignFeedItem class="mb-4" v-for="campaign of campaigns" :key="campaign._id" :campaign="campaign" :circle_id="circle_id" source="circle"
        :loggedInUser="loggedInUser" />
    </div>
    <EmptyCampaign :user="user" :loggedInUser="loggedInUser" v-if="campaigns && !campaigns.length" emptyCampaignFor="circle"
      :userCircles="userCircles"/>
    <ContentSkeleton v-if="contentLoading" class="mt-4" />
  </div>
</template>

<script>
    import ContentSkeleton from "../ContentSkeleton/ContentSkeleton.vue";
    import EmptyCampaign from '../EmptyCampaign/EmptyCampaign.vue';
    import CampaignFeedItem from '../CampaignFeedItem/CampaignFeedItem.vue';

    export default {
      name: "CircleCampaignList",
      props: ['user', 'loggedInUser', 'userCircles', 'contentLoading', 'campaigns', 'circle_id'],
      components: { ContentSkeleton, EmptyCampaign, CampaignFeedItem }
    }
</script>

<style scoped>

</style>